import React from "react";
import { Spinner } from "reactstrap";

const NotFound = () => {
    return (
        <div style={{ color: "red" }}>
            <h1>404 No Page</h1>
            <p>Try again, that page does not yet exist on this site</p>

            <Spinner
                color="danger"
                type="grow"
                style={{ width: "200px", height: "200px" }}
            />
            <Spinner
                color="primary"
                type="grow"
                style={{ width: "200px", height: "200px" }}
            />
        </div>
    );
};

export default NotFound;
